<template>
    <div>
      <h1>Home Contact</h1>
      <p>Welcome to the home page!</p>
    </div>
  </template>
  
  <script>
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Contact",
  };
  </script>
  
  <style scoped>
  /* Add styles for Home page */
  </style>
  